export default "__VITE_ASSET__BfYw0bOP__"